import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import TableComponent from "app/common/Component/Table/TableComponent";
import { getDateTime, getGender, hideMiddleDigits } from "app/common/LocalFunction";
import { observer } from "mobx-react";
import React, { memo, useState } from "react";
import { useTranslation } from "react-i18next";
import SaveIcon from "@material-ui/icons/Save";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import { toast } from "react-toastify";
import CopyableCodeCell from "app/common/Component/CopyableCodeCell";
import { COMPLAIN_STATUS } from "app/common/LocalConst";

const PopupDuplicate = ({
  open,
  handleClose,
  duplicatePatients,
  onSelectPatient,
  searchCheckIn,
  handleChangeFormSearch,
}) => {
  const { t } = useTranslation();
  const [selectedRow, setSelectedRow] = useState([]);
  console.log("searchCheckIn", searchCheckIn);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const handleCloseWithValidation = () => {
    if (!selectedRow?.[0]) {
      toast.warning(
        "Không được đóng khi chưa chọn khách hàng trong danh sách!"
      );
      return;
    }
    handleClose();
  };
  return (
    <PopupForm
      open={open}
      size="lg"
      handleClose={handleClose}
      title={`Danh sách khách hàng trùng thông tin check in`}
      formik={{}}
      hiddenClose={searchCheckIn?.hiddenClose}
      action={
        <div className="flex-center gap-1">
          <CommonButton
            className="btn-add"
            onClick={() => {
              if (!selectedRow?.[0]) {
                toast.warning("Vui lòng chọn một khách hàng trong danh sách!");
                return;
              }
              onSelectPatient(selectedRow?.[0]);
            }}
          >
            {!isMobile && <SaveIcon className="mr-2" />}
            Chọn khách hàng check in
          </CommonButton>
          {/* <CommonButton 
            className="btn-gray" 
            onClick={() => {
              if (!selectedRow?.[0]) {
                  toast.warning("Không được bỏ qua khi chưa chọn khách hàng trong danh sách!");
                  return;
                }
              handleClose()
            }}
          >
            {!isMobile && <Block className="mr-2" />}
            Bỏ qua lọc trùng
          </CommonButton> */}
        </div>
      }
    >
      <Grid container spacing={1}>
        {/* <Grid item xs={12}>
          <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: 8 }}>
            <GlobitsCheckBox
              label="Khách hàng không thuộc danh sách trên"
              name="isUnlistedPatient"
              onChange={(e) => {
                if (formikRef?.current?.setFieldValue) {
                  formikRef.current.setFieldValue("isUnlistedPatient", e.target.checked);
                }
                handleClose();
              }}
              style={{ fontWeight: 500 }} 
            />
          </div>
        </Grid> */}

        <Grid item xs={12}>
          <TableComponent
            data={duplicatePatients?.content || []}
            titleNodata={t("noData")}
            showOrdinalNumbers
            selectType={"single"}
            initStateRow={selectedRow}
            minWidth={800}
            handleChangeSelectedRows={(row) => setSelectedRow(row)}
            columns={[
              {
                field: "displayName",
                title: t("Tên khách hàng"),
                render: (patient) => (
                  <Tooltip title="Thông tin khách hàng">
                    <div>
                      <p>
                        <b>{patient?.displayName || patient?.fullName}</b>
                      </p>
                      <p>
                        <>
                          <span style={{ color: "#006778" }}>
                            <CopyableCodeCell value={patient?.code} size="small" />
                          </span>{" "}
                          {patient?.gender && (
                            <>|{getGender(patient?.gender)}</>
                          )}
                        </>
                      </p>
                    </div>
                  </Tooltip>
                ),
              },
              {
                field: "modifyDate", // hoặc field phù hợp hơn
                title: t("Ngày tạo"),
                render: (patient) => getDateTime(patient?.patientCreateDate),
              },
              {
                field: "phoneNumber",
                title: t("Số điện thoại"),
                align: "center",
                render: (data) => {
                  return (
                    <>
                      <div>
                        {data?.phoneNumber && <>SĐT 1: {hideMiddleDigits(data?.phoneNumber)} </>}
                        {data?.isMainPhoneNumber ? <>✔️</> : <></>}
                      </div>
                      <div>
                        {data?.subPhoneNumber && (
                          <>SĐT 2: {hideMiddleDigits(data?.subPhoneNumber)} </>
                        )}
                      </div>
                      <div>
                        {data?.phoneNumber3 && (
                          <>SĐT 3: {hideMiddleDigits(data?.phoneNumber3)} </>
                        )}
                      </div>
                      <div>
                        {data?.phoneNumber4 && (
                          <>SĐT 4: {hideMiddleDigits(data?.phoneNumber4)} </>
                        )}
                      </div>
                    </>
                  );
                },
              },
              {
                field: "currentTelesaleName",
                title: t("Telesale hiện thời"),
              },
              {
                field: "currentPatientSourceName",
                title: t("Nguồn"),
              },
              {
                field: "checkin",
                title: t("Trạng thái khiếu nại"),
                align: "center",
                render: (val) => {
                  const status = COMPLAIN_STATUS.find(
                    (el) => el?.value === val?.complainStatus
                  );
                  return (
                    <div className="flex justify-center">
                      <Tooltip title={status?.name || ""}>
                        <div className="flex align-center">
                          {status?.icon}
                          {isMobile && (
                            <span className="ml-1">{status?.name}</span>
                          )}
                        </div>
                      </Tooltip>
                    </div>
                  );
                },
              },
            ]}
            dataPagination={{
              pageIndex: searchCheckIn?.pageIndex,
              pageSize: searchCheckIn?.pageSize,
              totalElements: duplicatePatients?.totalElements,
              totalPages: duplicatePatients?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
};

export default memo(observer(PopupDuplicate));
